import ComCommune from './com-commune';
import AbstractModel, { Model, DateType } from './abstract-model';
import CavSourceInfo from "./cav-source-info";
import BeanCaviteAssociee from './bean-cavite-associee';
import CavEvtsSurface from './cav-evts-surface';
import CavPocAccesPossible from './cav-poc-acces-possible';
import CavPocDescriptionSommaire from './cav-poc-description-sommaire';
import CavPocScan from './cav-poc-scan';
import CavDocument from './cav-document';
import CavPhoto from './cav-photo';
import CavPocEnjeuxSurface from './cav-poc-enjeux-surface';
import CavPocEvenementObservation from './cav-poc-evenement-observation';
import CavPocObservationChiroptere from './cav-poc-observation-chiroptere';
import CavPocPilier from './cav-poc-pillier';
import CavPocPreconisation from './cav-poc-preconisation';
import CavPocTauxDefruitement from './cav-poc-taux-defruitement';
import CavPocRefCadastrale from './cav-poc-ref-cadastrale';
import CavPocSuivi from './cav-poc-suivi';
import CavPocProprietaire from './cav-poc-proprietaire';
import CavCus from './cav-cus';
import CavDdtm59Link from './cav-ddtm59-link';
import { LexCodeFiabilite } from './gen-lexs';

@Model('CavCavite')
export default class CavCavite extends AbstractModel {
  public numCavite: string = null;
  public typeCavite: string = null;
  public statut: string = null;
  public lambertOuvrage: number = null;
  public positionnement: string = null;
  public natureCavite: string = null;
  public reperageGeographique: string = null;
  public sourceCoordonnees: string = null;
  public numInsee: string = null;
  public confidentialite: string = null;
  public indiceBss: string = null;
  public designationBss: string = null;
  public nomCavite: string = null;
  public raisonConfidentialite: string = null;
  public organismeChxConfidentialite: string = null;
  public precisionXY: number = null;
  @DateType() public dateValidite: Date = null;
  public auteurDescription: string = null;
  public dateMajCavite:Date = null;
  public xouvrage: number = null;
  public youvrage: number = null;
  public zouvrage: number = null;
  public xouv93: number = null;
  public youv93: number = null;
  public commentaires: string = null;
  public caviteAssociee: string = null;
  public cuserSaisie: string = null;
  public cdateSaisie:Date = null;
  public cuserModif: string = null;
  @DateType() public dateValidationSaisie: Date = null;
  @DateType() public dateValidationDiffusion: Date = null;
  public userValidationSaisie: string = null;
  public userValidationDiffusion: string = null;
  public statutSaisie: number = 1;
  public statutDiffusion: number = 1;
  public dangerosite: string = null;
  public cavSourcesInfos: CavSourceInfo[] = [];
  public cavGeometrie: /*TODO CavGeometrie*/ any = null;
  public idGeometrie: number = null;
  public commune: ComCommune = null;
  public caviteAssocieeList: BeanCaviteAssociee[] = [];

  public precisionMateriau: number = null;
	public surfaceEmprise: number = null;
	public nbAcces: number = null;
	public profMinToit: number = null;
	public profMaxToit: number = null;
	public hauteurMoy: number = null;
	public etatCaviteEaux: string = null;
	public nbmaxSuperposes: number = null;
	public natureMateriau: number = null;
	public classeSurface: string = null;
	public profondeurMaxToit: number = null;
  public commentairesGeom: string = null;

  public cavEvtsSurface: CavEvtsSurface[] = [];

  //poc
  public pocInfosComplementaires: string = null;
	public accesPossibles: CavPocAccesPossible[] = [];
	public descriptionSommaires: CavPocDescriptionSommaire[] = [];
	public documents: CavDocument[] = [];
	public scans: CavPocScan[] = [];
	public photos: CavPhoto[] = [];
	public enjeuxSurfaces: CavPocEnjeuxSurface[] = [];
	public evenementObservations: CavPocEvenementObservation[] = [];
	public observationChiropteres: CavPocObservationChiroptere[] = [];
	public piliers: CavPocPilier[] = [];
	public preconisations: CavPocPreconisation[] = [];
	public proprietaires: CavPocProprietaire[] = [];
	public tauxDefruitements: CavPocTauxDefruitement[] = [];
	public refCadastrales: CavPocRefCadastrale[] = [];
  public suivis: CavPocSuivi[] = [];
  
  public cus: CavCus = null;

  //ddtm59
  public ddtm59Links: CavDdtm59Link[] = [];
  public lexCodeFiabilite: LexCodeFiabilite = null;

  
  public get xouv93Rounded(): string {
    if (this.xouv93 != null)
      return Math.round(Number(this.xouv93)) + "";

    return null;
  }

  public get youv93Rounded(): string {
    if (this.youv93 != null)
      return Math.round(Number(this.youv93)) + "";

    return null;
  }

  public get isInPoc(): boolean {
		return this.commune != null && (
			this.commune.numDept == '16'
			|| this.commune.numDept == '17'
			|| this.commune.numDept == '79'
			|| this.commune.numDept == '86');
	}
	
	public get isInEms(): boolean {
		return this.commune != null && (this.commune.numDept == '67');
  }

	public get isInDdtm59(): boolean {
		return this.commune != null && (this.commune.numDept == '59');
  }

}